/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 */

// The info card on each rail icon of the home left pane (hermes-agent-ui openspec
// unify-embed-rail-and-signin, "Every rail icon has an info card"), keyed by the
// entry's test id: the name and one line, at most 60 characters, no two alike.
export interface RailInfo { icon: string; title: string; line: string; }

export const RAIL_INFO: Record<string, RailInfo> = {
  "dm-overview": { icon: "Home", title: "Overview", line: "Recent documents and activity in this workspace" },
  "dm-ws-agents": { icon: "Users2", title: "K-Nets", line: "The K-Nets in this workspace" },
  "dm-ws-databases": { icon: "TypeTable", title: "Databases", line: "Tables and documents in this workspace" },
  "dm-ws-kb": { icon: "Book", title: "Knowledge Bases", line: "The knowledge bases in this workspace" },
  "dm-ws-apps": { icon: "Layers", title: "Connectors", line: "Third-party connectors for this workspace" },
  "dm-ws-maps": { icon: "World", title: "Maps", line: "The maps in this workspace" },
  "dm-ws-crawlers": { icon: "Search", title: "Crawlers", line: "The crawlers in this workspace" },
  "dm-chat": { icon: "Chat", title: "Chat", line: "Chat with agents about your data" },
  "dm-api": { icon: "Settings", title: "API", line: "API keys and access for this workspace" },
  "dm-whatsapp": { icon: "MobileChat", title: "Whatsapp", line: "WhatsApp numbers connected to this workspace" },
  "dm-voice": { icon: "Message", title: "Voice", line: "Voice agents for this workspace" },
  "dm-assistant": { icon: "Robot", title: "Kue", line: "Ask Kue to do things across KNet" },
  "dm-templates-page": { icon: "Board", title: "Examples & Templates", line: "Ready-made documents to start from" },
  "dm-trash": { icon: "RemoveBig", title: "Trash", line: "Deleted documents you can restore" },
  "dm-basic-tutorial": { icon: "Bookmark", title: "Tutorial", line: "A short guided tour of Databases" },
  "dm-help-center-placeholder": { icon: "Help", title: "Help Center", line: "Guides and answers for KNet" },
  "dm-accessibility-placeholder": { icon: "Accessibility", title: "Accessibility", line: "Keyboard and screen reader help" },
  "dm-tos": { icon: "Memo", title: "Terms of service", line: "The terms you agree to by using KNet" },
};
